


















import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({
  name: "policies",
})
export default class extends Vue {
  @Prop()
  inputRule: any;

  private linkArray: any = [
    "http://www.moa.gov.cn/",
    "http://www.greenfood.agri.cn/",
    "http://zs.qsst.moa.gov.cn",
    "http://nynct.fujian.gov.cn/",
    "http://www.anluyun.com/",
    "http://www.tea.agri.cn",
    "http://www.ietrace.com",
    "http://cx.aqsc.org/ConsumerInquiries/QueryHome",
    "http://www.cnfood.cn",
  ];
}
